import React from "react";

import { toggleModal } from "../../slices/popupSlice";
import { trackInteractionEvent } from "../../tracking/googleAnalytics";
import { useDispatch, useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";
import { INSURANCE_VARIANT } from "../insurance/Insurance.type";
import { MODAL_TYPES } from "../modals/GeneralModal.types";
import { ConfigServices } from "../product/ConfigServices";
import { Configuration } from "../product/Configuration";
import { Product } from "../product/Product";
import { RecommendedProductsList } from "../recommended-products/RecommendedProductsList";
import SubscriptionDetails from "../subscription/SubscriptionDetails";
import SubscriptionHighlight from "../subscription/SubscriptionHighlight";
import SubscriptionInfo from "../subscription/SubscriptionInfo";
import SubscriptionReadMore from "../subscription/SubscriptionReadMore";
import { Alert } from "../ui/Alert";
import { Loading } from "../ui/Loading";
import { Spacer } from "../ui/Spacer";

import { Footer } from "./Footer";
import { Header } from "./Header";

// import "./Popup.scss";

interface PopupPropsI {
	closePopup: () => void;
}

export const DrawerContent = (props: PopupPropsI) => {
	const dispatch = useDispatch();

	const isFetching = useSelector((state) => state.popup.isFetching);
	const isError = useSelector((state) => state.popup.error.isError);

	const isBoughtWithSubscription = useSelector(
		(state) =>
			state.popup.products.mainProduct.subscription?.isBoughtWithSubscription,
	);

	const showSubscriptionDataOnly = useSelector(
		(state) => state.popup.showSubscriptionDataOnly,
	);

	const insurance = useSelector(
		(state) => state.popup.products.mainProduct.insurance,
	);

	const insuranceModalType = insurance?.some(
		(item) => item.variant === INSURANCE_VARIANT.SCREEN,
	)
		? MODAL_TYPES.SCREEN_INSURANCE
		: MODAL_TYPES.INSURANCE;

	const close = () => {
		trackInteractionEvent({
			action: "PopupClosed",
			category: "CartPopup",
		});

		props.closePopup();

		if (insurance?.length) {
			dispatch(
				toggleModal({
					id: insuranceModalType,
					isOpen: true,
				}),
			);
		}
	};

	const continueShopping = () => {
		trackInteractionEvent({
			action: "ClickedContinueShopping",
			category: "CartPopup",
		});

		props.closePopup();

		if (insurance?.length) {
			dispatch(
				toggleModal({
					id: insuranceModalType,
					isOpen: true,
				}),
			);
		}
	};

	const goToCart = () => {
		trackInteractionEvent({
			action: "ClickedGoToCart",
			category: "CartPopup",
		});

		props.closePopup();

		if (insurance.length) {
			dispatch(
				toggleModal({
					id: insuranceModalType,
					isOpen: true,
					config: { redirectUrl: "/cart" },
				}),
			);
		} else {
			window.location.href = "/cart";
		}
	};

	return (
		<div className="addtocart-popup__content">
			<Header closePopup={close} />
			{isFetching && <Loading label={strings.loading} />}

			{isError ? (
				<>
					{showSubscriptionDataOnly ? (
						<>
							<SubscriptionHighlight isInfoModal />
							<Spacer variant="medium" />
							<Alert />
						</>
					) : (
						<>
							<Alert />
							<Footer
								continueShopping={continueShopping}
								goToCart={goToCart}
							/>
						</>
					)}
				</>
			) : (
				<>
					{showSubscriptionDataOnly ? (
						<SubscriptionInfo />
					) : (
						<div>
							<Product />
							<ConfigServices />
							<RecommendedProductsList />
							{isBoughtWithSubscription && <SubscriptionDetails />}
							<Footer
								continueShopping={continueShopping}
								goToCart={goToCart}
							/>
							{isBoughtWithSubscription && (
								<>
									<SubscriptionHighlight />
									<SubscriptionReadMore />
								</>
							)}

							<Configuration />
						</div>
					)}
				</>
			)}
		</div>
	);
};
